<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
    <div class="text-xs-center">
      <img src="../../assets/presentacion/diapositiva-5.png" alt="petrolera">
      <router-link to="/modulo1/0" class="modulo"><span class="wrapper wrapper-1"><span class="numero_modulo">M1</span></span>&nbsp;<span class="texto_modulo"><span class="titulo_modulo">Módulo 1:</span> Aspectos generales y marco regulatorio</span></router-link>
    </div>
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Presentacion/AUDIO 14'
    ]"></audio-player> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogos: [
        "Iniciemos con el módulo 1." 
      ]
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  }
}
</script>
<style lang="scss" scoped>
.modulo {
  display: inline-block;
  
  &:hover {
    .texto_modulo::after {
      width: 100%;
    }
  }
}
.texto_modulo {
  flex: 1 1 70%;
  text-align: left;
  display: inline-block;
  color: black;
  font-family: helveticaNeueCn;
  font-weight: bold;
  padding: 5px;
  font-size: 1.2rem;
  padding-left: 2.2rem;
  position: relative;
  left: -2rem;
  width: 500px;
  max-width: calc(100vw - 70px);
  line-height: 1em;
  z-index: 1;
  &::before, &::after {
    z-index: -1;
    position: absolute;
    content: " ";
    display: block;
    top: 0;
    left: 0;
    height: 100%;
    width: 0;
    background-color: white;
    transition: width 200ms;
  }
  &::before {
    background-color: #F9DB14;
    width: 100%;
  }
  @media (max-width: 960px) and (orientation: portrait) {
    font-size: 1rem;
  }
}

.wrapper {
  padding: 20px;
  display: inline-block;
  border-radius: 100%;
  background-size: 100% 100%;
  &.wrapper-1{
    background-image: url('../../assets/textura-M1.png');
  }
  &.wrapper-2{
    background-image: url('../../assets/textura-M2.png');
  }
  &.wrapper-3{
    background-image: url('../../assets/textura-M3.png');
  }
}

.numero_modulo {
  flex: 1 0;
  position: relative;
  z-index: 2;
  background-color: #004535;
  border: 2px solid white;
  border-radius: 100%;
  padding-top: 0.3em;
  font-size: 1.2em;
  display: inline-block;
  width: 2.3em;
  height: 2.3em;
  max-width: 2.3em;
  max-height: 2.3em;
  text-align: center;
  color: white;
}

.titulo_modulo {
  color: #004535;
}
</style>
